<template>
  <RappresentanteDialogCore
    :modelValue="modelValue"
    :available="available"
    :initialIdentifier="initialIdentifier"
    :embedded="embedded"
    inline
    mode="create"
    @update:modelValue="$emit('update:modelValue', $event)"
    @created="$emit('created', $event)"
  />
</template>

<script>
import RappresentanteDialogCore from '@/components/ask/details/RappresentanteDialogCore.vue'

export default {
  components: { RappresentanteDialogCore },
  props: {
    modelValue: Boolean,
    available: Boolean,
    initialIdentifier: { type: String, default: '' },
    embedded: Boolean
  },
  emits: ['update:modelValue', 'created']
}
</script>
